require('~/scss/style.scss')

/* eslint-disable no-unused-vars */
import 'jquery-modal'
import 'magnific-popup'
import './autocomplete'
import './modal'
import './cancel-order-scripts'
import './set-header-margin'
import {
  initDeliveryDateCalendar,
  initDeliveryDateRange,
  initMainDeliveryBanner,
} from './delivery-date-calendar'
import './fields'
import './get-args-pass'
import './qty-update'
import addAddressToMetafield from './add-address-metafield'
import addAppUidToMetafield from './add-app-uid-metafield'
import 'jp-prefecture'
import 'lazysizes'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'lazysizes/plugins/bgset/ls.bgset'
import { initAddressForms } from './address'
import { bindModalClose } from './modal-order-curtain-confirm'
import './barcode-generator'
import { checkForAppUid } from './login'
import './forms/inputValidations'

import './zendesk-cookie'
import setUtmParameters from './utm-parameters'
import orderDetails from './pages/order-details'
import '~/js/sections/categoryAccordion'
import '~/js/snippets/smart-up-banner'
import '~/js/gtm'
import '~/js/points/login'

orderDetails()

const $doc = $(document)

$doc.ready(() => {
  bindModalClose()

  //UTM parameters
  setUtmParameters()

  if (window.location.href.includes('account')) {
    // bindPointsStatus(); - migrated to omo.js
    addAddressToMetafield()
    addAppUidToMetafield()
    checkForAppUid()
  }

  if (window.location.href.includes('/pages/delivery_calendar')) {
    initDeliveryDateRange()
    initMainDeliveryBanner()
    initDeliveryDateCalendar()
  }

  if (window.location.href.includes('/account?view=addresses')) {
    initAddressForms()
  }

  if (window.location.href.includes('/orders/')) {
    $('#receipt-popup .btn-close').click((e) => {
      e.preventDefault()
      $.magnificPopup.close()
    })
  }
})

//Details Popup
$('.popup-link').magnificPopup({
  type: 'inline',
  closeBtnInside: false,
  midClick: true,
})
